/**
 * External dependencies
 */
import classnames from 'classnames'

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks'
import { InnerBlocks } from '@wordpress/block-editor'

const save = props => {
	const {
		attributes,
	} = props

	const {
		enableContainer,
		enablemaxwidth,
		width,
		className,
	} = attributes

	const mainClasses = classnames( [
		'czgb-container-block',
		className,
		enableContainer ? 'container' : '',
	], applyFilters( 'cartzillagb.container.main-block.classes', {}, props ) )


	const htmlAttr = {}

	if( enablemaxwidth === true ) {
		htmlAttr.style = {
			maxWidth: `${ width }rem`,
		}
	}

	return (
		<div  className={ mainClasses } { ...htmlAttr }>            
			<InnerBlocks.Content />
		</div>
	)  
}

export default save